var _linearGradient, _linearGradient2, _linearGradient3, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgConfluence = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: 2400,
  viewBox: "-0.022 0.04 256.072 245.94",
  width: 2500,
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
  id: "a"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#0052cc"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.92,
  stopColor: "#2380fb"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2684ff"
}))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  gradientUnits: "userSpaceOnUse",
  x1: 243.35,
  x2: 83.149,
  xlinkHref: "#a",
  y1: 261.618,
  y2: 169.549
})), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  gradientUnits: "userSpaceOnUse",
  x1: 12.633,
  x2: 172.873,
  xlinkHref: "#a",
  y1: -15.48,
  y2: 76.589
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.11 187.79c-2.64 4.3-5.63 9.34-7.99 13.33-.52.89-.85 1.88-1 2.9a8.13 8.13 0 0 0 .16 3.07c.24 1.01.68 1.95 1.28 2.79s1.36 1.56 2.23 2.12l53.03 32.69c.91.57 1.94.95 3.01 1.12 1.06.17 2.16.13 3.21-.13s2.04-.72 2.91-1.36 1.6-1.45 2.15-2.38c2.14-3.56 4.85-8.17 7.76-13.09 21.02-34.47 42.32-30.25 80.37-12.16l52.6 24.94a8.13 8.13 0 0 0 6.35.29c1.02-.38 1.96-.96 2.75-1.71.8-.75 1.43-1.65 1.87-2.65l25.25-56.93c.43-.96.67-1.99.7-3.04.04-1.04-.13-2.09-.49-3.07s-.9-1.89-1.6-2.67-1.54-1.41-2.49-1.88c-11.09-5.22-33.16-15.49-52.94-25.17-71.95-34.71-132.66-32.42-179.12 42.99z",
  fill: "url(#b)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M246.88 58.38c2.67-4.3 5.66-9.33 7.99-13.32.53-.91.88-1.92 1.03-2.97.15-1.04.09-2.11-.17-3.13a8.155 8.155 0 0 0-1.36-2.83 8.09 8.09 0 0 0-2.33-2.11L199.09 1.33c-.92-.57-1.94-.95-3.01-1.12s-2.16-.12-3.21.13c-1.05.26-2.04.72-2.91 1.36s-1.6 1.45-2.16 2.38c-2.09 3.56-4.85 8.17-7.76 13.09-21.1 34.63-42.2 30.41-80.29 12.32L47.2 4.54c-.98-.47-2.04-.75-3.12-.81-1.08-.07-2.17.09-3.19.45s-1.96.92-2.76 1.65c-.81.73-1.45 1.61-1.91 2.59L10.97 65.51a8.191 8.191 0 0 0-.23 6.13c.36.99.91 1.9 1.61 2.68s1.55 1.42 2.5 1.88c11.13 5.23 33.2 15.49 52.94 25.18 71.76 34.7 132.66 32.42 179.09-43z",
  fill: "url(#c)"
})));

export default SvgConfluence;